// Script to open the size guide modal when clicking the size guide button

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.size-guide-btn');
  const modal = document.querySelector('.size-guide-modal');
  const overlay = document.querySelector('.size-guide-modal .overlay');
  const closeBtn = document.querySelector('.size-guide-close');

  if (!btn || !modal) return;

  btn.addEventListener('click', function () {
    modal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent background scroll
  });

  function closeModal() {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (overlay) {
    overlay.addEventListener('click', closeModal);
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
});
